import config from 'config';
import { createClientAuth } from '@whoop/auth-client';

const auth = createClientAuth({
  env: config.env.toLowerCase(), // the client does no normalization on environment aliases, so we lowercase it here
  segmentKey: ''
});

export default auth;
